export default {
  NEW: {
    value: 'new',
    label: '新品',
  },
  SPECIAL: {
    value: 'special',
    label: '特价品',
  },
  NORMAL: {
    value: "normal",
    label: "现行品",
  },
}
